import { signal } from '@preact/signals';

export const previousRoute = signal('');
